import React from 'react';
import { bonuses } from '../../data/content';
import { CtaButton } from '../CtaButton';
export function Bonuses() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-103" data-mp="1hjhebpwvk51x">
      <div className="mx-auto w-full max-w-3xl" data-id="element-104" data-mp="1cko6ad0cx695">
        <div className="text-center" data-id="element-105" data-mp="1clfx7aj0eft3">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-106" data-mp="18juhzij05pfq">
            Bonuses
          </p>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-107" data-mp="258shtf5m0djr">
            🎁 5 exclusive bonuses from Dr. Karito
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-graphite/75 sm:text-base" data-id="element-108" data-mp="1w8nlc01yezkd">
            Each bonus eliminates one of the situations that can cost you the
            most time, create uncertainty, or lead to avoidable mistakes during
            a consultation. The goal isn’t to make you study more — it’s to give
            you the right clinical tool when you need it most.
          </p>
        </div>

        <ul className="mt-10 flex flex-col gap-4" data-id="element-109" data-mp="1euye85rhafcu">
          {bonuses.map(bonus => <li key={bonus.number} className="-mx-4 overflow-hidden bg-white shadow-card ring-1 ring-ink/[0.07] sm:mx-0 sm:rounded-2xl" data-id="element-110" data-mp="1jror6k7zkuu1">
              <div className="flex items-center gap-2 bg-ink px-4 py-2.5" data-id="element-111" data-mp="1arjvh7c5nkvp">
                <span aria-hidden="true" className="text-sm" data-id="element-112" data-mp="w35nyj3sn88t">
                  🎁
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-113" data-mp="10tlztyryult2">
                  Bonus #{bonus.number}
                </span>
              </div>

              <img src={bonus.image} alt={bonus.alt} className="block w-full bg-white" width={1256} height={1256} loading="lazy" data-id="element-114" data-mp="n0nyzwwr81i4" />

              <div className="px-4 pb-5 pt-1 sm:p-5 sm:pt-2" data-id="element-115" data-mp="i2corl2jrozd">
                <h3 className="font-display text-xl font-bold leading-snug text-ink" data-id="element-116" data-mp="2jsjxqntdjrl1">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-graphite/75 sm:text-[15px]" data-id="element-117" data-mp="2f0se6x8mym4e">
                  {bonus.text}
                </p>
                <p className="mt-4 flex flex-wrap items-center gap-2 text-[12px] font-bold uppercase tracking-[0.1em]" data-id="element-118" data-mp="2axvrauc2c3un">
                  <span className="text-graphite/50 line-through" data-id="element-119" data-mp="32r5wvx5bz8mb">
                    Value: {bonus.value}
                  </span>
                  <span className="rounded-full bg-blood/10 px-2.5 py-1 text-blood" data-id="element-120" data-mp="2yqvqijdmmg6x">
                    Free today
                  </span>
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl bg-ink p-6 text-center ring-1 ring-ink" data-id="element-121" data-mp="2orep4e5eqogr">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-white/60" data-id="element-122" data-mp="1icdp9xd9hm4w">
            Total bonus value
          </p>
          <p className="mt-2 font-display text-4xl font-bold text-blood sm:text-5xl" data-id="element-123" data-mp="1deue56bv1ph6">
            $150 USD
          </p>
          <p className="mt-3 text-[14px] font-medium leading-relaxed text-white/70" data-id="element-124" data-mp="187e4cnv8db4h">
            Today, you get all 5 bonuses at no additional cost.
          </p>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-125" data-mp="1d4w53qz3gk1e">
          <CtaButton label="I want all 5 bonuses free" data-id="element-126" data-mp="1hyihrj59cnx7" />
        </div>
      </div>
    </section>;
}